'use client'
import {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react'

type AuthenticationDialogContextType = {
  isOpen: boolean
  setOpen: (shouldOpen: boolean) => void
}

const AuthenticationDialogContext =
  createContext<AuthenticationDialogContextType>(
    {} as AuthenticationDialogContextType,
  )

export function AuthenticationDialogProvider({ children }: PropsWithChildren) {
  const [isOpen, setOpen] = useState<boolean>(false)

  const value = useMemo(
    () => ({
      isOpen,
      setOpen,
    }),
    [isOpen, setOpen],
  )

  return (
    <AuthenticationDialogContext.Provider value={value}>
      {children}
    </AuthenticationDialogContext.Provider>
  )
}

export function useAuthenticationDialog() {
  const context = useContext(AuthenticationDialogContext)

  if (!context) {
    throw new Error(
      'useAuthenticationDialog must be used within a AuthenticationDialogProvider',
    )
  }

  return context
}
